import { Injectable } from '@angular/core';
import { HttpService } from 'src/app/services/http.service';
import { environment } from "src/environments/environment";
import { Synchronization, Company, CreateSynchronizationContract } from './synchronization.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SynchronizationActivateComponent } from './synchronization-activate/synchronization-activate.component';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class SynchronizationService {

  constructor(
    private http: HttpService,
    private ngmService: NgbModal,
    private httpClient: HttpClient
  ) { }

  async refreshActivationKey(synronizationId: string): Promise<any> {
    return await this.http.get<any>(`${environment.adminConfig.apiUri}/synchronization/refreshactivation/${synronizationId}`);
  }
  async getSynchronization(synronizationId: string): Promise<Synchronization> {
    return await this.http.get<Synchronization>(`${environment.adminConfig.apiUri}/synchronization/${synronizationId}`);
  }

  async createSynchronization(synchronization: CreateSynchronizationContract): Promise<string> {
    return await this.http.post(`${environment.adminConfig.apiUri}/synchronization/create`, synchronization);
  }

  async isActivated(synchronizationId: string): Promise<boolean> {
    return await this.http.get<boolean>(`${environment.adminConfig.apiUri}/synchronization/isactivated/${synchronizationId}`);
  }

  async updateSynchronization(synchronization: Synchronization): Promise<void> {
    return await this.http.put(`${environment.adminConfig.apiUri}/synchronization`, synchronization);
  }

  async deleteSynchronization(synchronizationId: string): Promise<void> {
    return await this.http.delete(`${environment.adminConfig.apiUri}/synchronization/${synchronizationId}`);
  }

  async activateSynchronization(activatationKey: string, externalKey: string): Promise<any> {
    const data = { activationkey: activatationKey, externalkey: externalKey };

    let options = { headers: new HttpHeaders() };
    return await this.http.post<any, any>(`${environment.adminConfig.syncApiUrl}/public/signcontract`, data, null, options);
  }

  async showActivateSync(activatationKey: string) {
    const modalRef = this.ngmService.open(SynchronizationActivateComponent, { size: 'lg', backdrop: 'static' });
    modalRef.componentInstance.activatationKey = activatationKey;
    return modalRef.result.then(async (x: any) => { return true; }, (y: any) => { return false; });
  }

  async getCompanies(companyId: number): Promise<Company[]> {
    return await this.http.get<Company[]>(`${environment.adminConfig.apiUri}/synchronization/company/list/${companyId}`);
  }

 // Headquater funktioner
  downloadConsoleApp() {
    return this.httpClient.get(`${environment.adminConfig.apiUri}/synchronization/hq/downloadsyncconsole`, {
      responseType: 'blob'  // Use 'blob' as response type to handle binary data
    });
  }

}
